import { useLayoutEffect, useRef } from "react";
import "./OutageBanner.css";

const LABEL = process.env.REACT_APP_OUTAGE_BANNER_LABEL;
const MESSAGE = process.env.REACT_APP_OUTAGE_BANNER_MESSAGE;
// The flag and a message are required; the label is optional.
const ACTIVE = process.env.REACT_APP_OUTAGE_BANNER === "true" && !!MESSAGE;

const OutageBanner = () => {
  const bannerRef = useRef(null);

  useLayoutEffect(() => {
    if (!ACTIVE) return undefined;

    document.body.classList.add("outage-active");

    const el = bannerRef.current;
    // The fixed header, breadcrumbs and main offset themselves by this height,
    // which changes when the message wraps or a webfont loads late.
    const publish = (height) =>
      document.documentElement.style.setProperty(
        "--outage-banner-h",
        `${height}px`
      );

    // Publish before the first paint so the chrome never renders unshifted.
    publish(el.getBoundingClientRect().height);

    const observer = new ResizeObserver(([entry]) =>
      publish(entry.target.getBoundingClientRect().height)
    );
    observer.observe(el);

    return () => {
      observer.disconnect();
      document.body.classList.remove("outage-active");
      document.documentElement.style.removeProperty("--outage-banner-h");
    };
  }, []);

  if (!ACTIVE) return null;

  return (
    <div
      className="outage-banner"
      role="region"
      aria-label={LABEL || "Service notice"}
      ref={bannerRef}
    >
      <div className="outage-banner-inner">
        {LABEL && <span className="outage-banner-label">{LABEL}</span>}
        <span className="outage-banner-text">{MESSAGE}</span>
      </div>
    </div>
  );
};

export default OutageBanner;
